import { Drawer } from '@mui/material';
import { useDrawerContext } from 'context/DrawerContext';
import useResponsive from 'hook/useResponsive';
import DrawerContent from './DrawerContent';

const Sidebar = () => {
  const { isMdDown } = useResponsive();
  const { openDrawer, setOpenDrawer, drawerWidth } = useDrawerContext();

  return (
    <>
      <Drawer
        onClose={() => setOpenDrawer(false)}
        variant={isMdDown ? 'temporary' : 'permanent'}
        open={openDrawer}
        anchor='left'
        PaperProps={{
          id: 'sidebar-scroll',
        }}
        sx={{
          width: drawerWidth,
          transition: 'width ease-out 200ms',
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            border: 'none',
            bgcolor: 'common.white',
            borderRadius: 0,
            boxShadow: '5px 0px 10px  #15223214',
            transition: 'width ease-out 200ms',
          },
        }}
      >
        <DrawerContent />
      </Drawer>
    </>
  );
};

export default Sidebar;
